import { IResultData } from "@/domain/entities/shared/result";
import { defineStore } from "pinia";
import { container } from "@/ioc/inversify.config";
import TYPES from "@/ioc/identifiers";
import { IGuideInfoData } from "@/domain/entities/guide";
import { IGuideRepository } from "@/repositories/guide/guideRepository.types";
import { GuideTypeCode } from "@/types";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";

interface IGuideState {
  guideInfos: IGuideInfoData[];
}
const guideRepository = () => {
  return container.get<IGuideRepository>(TYPES.IGuideRepository);
};

export const useGuideStore = defineStore("guide", {
  state: (): IGuideState => {
    return {
      guideInfos: [],
    };
  },
  getters: {},
  actions: {
    async getGuideInfos(): Promise<IResultData<IGuideInfoData[]>> {
      const guideInfosResult: IResultData<IGuideInfoData[]> = {
        isSuccess: false,
        data: [],
      };

      await guideRepository()
        .getGuideInfos()
        .then((result) => {
          result
            .map((guideInfos) => {
              guideInfosResult.isSuccess = true;
              guideInfosResult.data = guideInfos;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(guideInfosResult, error);
              guideInfosResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          guideInfosResult.errorMessage = error.message;
        });

      this.guideInfos = guideInfosResult.data ?? [];
      return guideInfosResult;
    },

    async getGuideInfosOnLogout(): Promise<IResultData<IGuideInfoData[]>> {
      const guideInfosResult: IResultData<IGuideInfoData[]> = {
        isSuccess: false,
        data: [],
      };

      await guideRepository()
        .getGuideInfosOnLogout()
        .then((result) => {
          result
            .map((guideInfos) => {
              guideInfosResult.isSuccess = true;
              guideInfosResult.data = guideInfos;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(guideInfosResult, error);
              guideInfosResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          guideInfosResult.errorMessage = error.message;
        });

      this.guideInfos = guideInfosResult.data ?? [];
      return guideInfosResult;
    },

    async getOperationInfos(): Promise<IResultData<IGuideInfoData[]>> {
      const operationInfosResult: IResultData<IGuideInfoData[]> = {
        isSuccess: false,
        data: [],
      };

      await guideRepository()
        .getOperationInfos()
        .then((result) => {
          result
            .map((guideInfos) => {
              operationInfosResult.isSuccess = true;
              operationInfosResult.data = guideInfos;
            })
            .mapErr((error) => {
              useSetResultCodeIfNeeded(operationInfosResult, error);
              operationInfosResult.errorMessage = error.message;
            });
        })
        .catch((error) => {
          operationInfosResult.errorMessage = error.message;
        });

      this.guideInfos = operationInfosResult.data ?? [];
      return operationInfosResult;
    },
  },
});
